import { api } from "../../../../api/Middleware";
import {
  ACTIVITIES_URL,
  ACTIVITIES_COMPLETE_URL,
  ACTIVITIES_TODAY_URL,
  ACTIVITIES_OVERDUE_URL,
  ACTIVITIES_BULK_COMPLETE_URL,
} from "../../../../api/Urls";

export const getActivities = async (params = {}) => {
  const response = await api.get(ACTIVITIES_URL, { params });
  return response.data;
};

export const getActivity = async (id) => {
  const response = await api.get(`${ACTIVITIES_URL}${id}/`);
  return response.data;
};

export const createActivity = async (data) => {
  const response = await api.post(ACTIVITIES_URL, data);
  return response.data;
};

export const updateActivity = async (id, data) => {
  const response = await api.patch(`${ACTIVITIES_URL}${id}/`, data);
  return response.data;
};

export const deleteActivity = async (id) => {
  const response = await api.delete(`${ACTIVITIES_URL}${id}/`);
  return response.data;
};

export const completeActivity = async (id, resultNotes = "") => {
  const response = await api.post(ACTIVITIES_COMPLETE_URL(id), {
    result_notes: resultNotes,
  });
  return response.data;
};

export const getTodayActivities = async () => {
  const response = await api.get(ACTIVITIES_TODAY_URL);
  return response.data;
};

export const getOverdueActivities = async () => {
  const response = await api.get(ACTIVITIES_OVERDUE_URL);
  return response.data;
};

export const bulkCompleteActivities = async (ids) => {
  const response = await api.post(ACTIVITIES_BULK_COMPLETE_URL, { ids });
  return response.data;
};
